export default "__VITE_ASSET__CmaxYQON__"